import moment from 'moment';
import {DateRange, TimeScale} from '../../../../../types';
import {Formatter} from '../../../../../types';
import {xAxisFormatters} from '../constants';
import {SHOW_HOURS_LIMIT} from '../constants';
import {timeFormatter} from '../utils';

export interface UseTimeRangeFormatter extends DateRange {
    timeScale: TimeScale;
}

const useTimeRangeFormatter = ({
    startDate,
    endDate,
    timeScale
}: UseTimeRangeFormatter): Formatter<string | number> => {
    const start: moment.Moment = moment(startDate);
    const end: moment.Moment = moment(endDate);
    const duration = moment.duration(end.diff(start));
    const hours = duration.asHours();

    const isTimeFormatter = timeScale === TimeScale.HOURLY && hours < SHOW_HOURS_LIMIT;

    if (isTimeFormatter) {
        return timeFormatter;
    }

    return xAxisFormatters[timeScale];
};

export default useTimeRangeFormatter;
